import _ from 'underscore';
import $ from 'jquery';

export default class OfferCampaignMassSendReport {
  constructor($scope, OfferCampaignService) {
    $scope.$on('show_mass_send_report', function(event, data) {
      
      $.fancybox.close();
      $scope.filter  = {
        offer_campaign_id: data.campaigns
      };
      $scope.created_times = data.created_times.map(Number);
      $scope.sent_times = data.sent_times.map(Number);
      $scope.sum_sent_times = _.reduce(data.sent_times, function(memo, num){ return memo + num; }, 0).toFixed(2);
      $scope.sum_created_times = _.reduce(data.created_times, function(memo, num){ return memo + num; }, 0).toFixed(2);
      $scope.sum_all_times = $scope.sum_time($scope.sum_sent_times,$scope.sum_created_times);
      OfferCampaignService.get($scope.filter).success(function(data) {
        $scope.campaigns = data.campaigns;
        $scope.links = [];
        $scope.links_all_rec = [];
        $scope.links_gen_rec = [];
        $scope.links_spec_rec = [];
        $scope.links_sent_rec = [];
        _.each($scope.campaigns, function(campaign){
          $scope.links.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/' + campaign.id);
          $scope.links_all_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/' + campaign.id);
          $scope.links_gen_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/pending/general/' + campaign.id);
          $scope.links_spec_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/pending/special/' + campaign.id);
          $scope.links_sent_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/sent/' + campaign.id);
        });
        window.openFancyboxDialog('div#offer_campaign_mass_send_report');
        $.fancybox.open();
      });

    });
    
    $scope.sum = function(a,b) {
      return (parseInt(a) + parseInt(b));
    };
    
    $scope.sum_time = function(a,b) {
      return (Number(a) + Number(b)).toFixed(2);
    };

    $scope.sub = function(a,b) {
      return (parseInt(a) - parseInt(b));
    };
  }
}

OfferCampaignMassSendReport.$inject = ['$scope', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-mass-send-report.ctrl.js